export enum ListTypeCard {
  visa = 'VISA',
  mastercard = 'MASTERCARD',
  cb = 'CB'
}

export class PaymentCard {
  PaymentMethodCardId: number;
  CardBrand: string;
  CardHolderName: string;
  CardNumer: string;
  CardExpiryDate: string;
  CardByDefault: boolean;
  DtCreation: Date;
}

export class FournisseurCardsModel {
  fournisseurId: number;
  cardsList: PaymentCard[];
  defaultCardId: number;
}
